import React from "react";
import Link from "../link";
import PhotoCardPhotos from "./PhotoCardPhotos";
import PhotoCardData from "./PhotoCardData";
import PhotoCardMenu from "./PhotoCardMenu";
import { Container, Card, Overlay, Footer } from "./styled/photo-card";
function PhotoCard(_a) {
    var url = _a.url, name = _a.name, _b = _a.photos, photos = _b === void 0 ? ["", "", ""] : _b, lineOne = _a.lineOne, lineTwo = _a.lineTwo, hasLineTwo = _a.hasLineTwo, lineTwoFallback = _a.lineTwoFallback, hasLineTwoFallback = _a.hasLineTwoFallback, shouldHaveTwoLines = _a.shouldHaveTwoLines, footer = _a.footer, isDeleting = _a.isDeleting, showMenu = _a.showMenu, deleteLabel = _a.deleteLabel, handleClickDelete = _a.handleClickDelete, _c = _a.handleClickLink, handleClickLink = _c === void 0 ? function (e) { } : _c;
    return (React.createElement(Container, null,
        React.createElement(Card, null,
            React.createElement(Card.Header, { onClick: handleClickLink },
                React.createElement(Link, { to: url },
                    React.createElement(PhotoCardPhotos, { photos: photos }))),
            React.createElement(Card.Body, { onClick: handleClickLink },
                React.createElement(Link, { to: url },
                    React.createElement(PhotoCardData, { name: name, lineOne: lineOne, lineTwo: lineTwo, hasLineTwo: hasLineTwo, lineTwoFallback: lineTwoFallback, hasLineTwoFallback: hasLineTwoFallback, shouldHaveTwoLines: shouldHaveTwoLines }))),
            React.createElement(Card.Footer, null,
                footer && React.createElement(Footer, null, footer),
                showMenu && (React.createElement(PhotoCardMenu, { deleteLabel: deleteLabel, handleClickDelete: handleClickDelete })))),
        isDeleting && React.createElement(Overlay, null)));
}
export default PhotoCard;
